import * as React from 'react';
import { emporiModule } from '@empori/util';
import { LoadingSkeleton } from './components/skeletons';
export function render(element, container) {
    import(/* webpackChunkName: "create-root" */ 'react-dom/client')
        .then(function (r) {
        if (!container) {
            return;
        }
        r.createRoot(container).render(element);
    });
}
var ImageGalleryWithLogo = React.lazy(function () {
    return import(/* webpackChunkName: "image-gallery-logotypes" */ './components/ImageGalleryWithLogo');
});
var TestimonialContent = React.lazy(function () {
    return import(/* webpackChunkName: "testimonial" */ './components/Testimonial');
});
var LogoGrid = React.lazy(function () {
    return import(/* webpackChunkName: "logo-grid" */ './components/StaticLogoTypes');
});
var ProductItem = React.lazy(function () {
    return import(/* webpackChunkName: "product-item" */ './components/ProductItem');
});
emporiModule('gepositLoaded', {
    geposit: {
        InitMainNavigation: function (mainNav, mobileTrigger) {
            import(/* webpackChunkName: "main-navigation" */ './alterNav')
                .then(function (fn) { return fn.default(mainNav, mobileTrigger); });
        },
        InitFooterForm: function () {
            import(/* webpackChunkName: "footer-form" */ './footerForm')
                .then(function (fn) { return fn.default(); });
        },
        InitAnchorLinkNavigation: function () {
            import(/* webpackChunkName: "anchor-navigation" */ './anchorNavigation')
                .then(function (fn) { return fn.default(); });
        },
        InitImageGalleryWithLogo: function (el, model) {
            render(React.createElement(React.Suspense, { fallback: React.createElement(LoadingSkeleton, null) },
                React.createElement(ImageGalleryWithLogo, { model: model, parent: el })), el);
        },
        InitTestimonialCarousel: function (el, model) {
            render(React.createElement(React.Suspense, { fallback: React.createElement(LoadingSkeleton, null) },
                React.createElement(TestimonialContent, { testimonials: model })), el);
        },
        InitLogoGrid: function (el, model) {
            render(React.createElement(React.Suspense, { fallback: React.createElement(LoadingSkeleton, null) },
                React.createElement(LogoGrid, { logos: model })), el);
        },
        InitProductItems: function (el, items) {
            render(React.createElement(React.Suspense, { fallback: React.createElement(LoadingSkeleton, null) },
                React.createElement(ProductItem, { products: items })), el);
        }
    }
});
